import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/components/Main';
import EnglishConsentForm from '@/components/EnglishConsentForm';
import Demographics from '@/components/Demographics';
import TamilConsentForm from '@/components/TamilConsentForm';
import HindiConsentForm from '@/components/HindiConsentForm';
import MarathiConsentForm from '@/components/MarathiConsentForm';
import EnglishParticipationInfo from '@/components/EnglishParticipationInfo';
import TamilParticipationInfo from '@/components/TamilParticipationInfo';
import HindiParticipationInfo from '@/components/HindiParticipationInfo';
import MarathiParticipationInfo from '@/components/MarathiParticipationInfo';
import Summary from '@/components/Summary';
import Tests from '@/components/Tests';
import Results from '@/components/Results';
import CheckResults from '@/components/CheckResults';
import LanguageSelection from '@/components/LanguageSelection';
import Login from '@/components/login/Login';
import ForgotPassword from '@/components/login/ForgotPassword';
import Data from '@/components/Data';
import Dashboard from '@/components/Dashboard';
import ga from 'vue-ga';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/data',
      name: 'Data',
      component: Data,
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
    },
    {
      path: '/demographics/:language',
      name: 'Demographics',
      component: Demographics,
      props: true,
    },
    {
      path: '/consent-form-tamil',
      name: 'TamilConsentForm',
      component: TamilConsentForm,
    },
    {
      path: '/consent-form-english',
      name: 'EnglishConsentForm',
      component: EnglishConsentForm,
    },
    {
      path: '/consent-form-hindi',
      name: 'HindiConsentForm',
      component: HindiConsentForm,
    },
    {
      path: '/consent-form-marathi',
      name: 'MarathiConsentForm',
      component: MarathiConsentForm,
    },
    {
      path: '/participation-info-tamil',
      name: 'TamilParticipationInfo',
      component: TamilParticipationInfo,
    },
    {
      path: '/participation-info-english',
      name: 'EnglishParticipationInfo',
      component: EnglishParticipationInfo,
    },
    {
      path: '/participation-info-hindi',
      name: 'HindiParticipationInfo',
      component: HindiParticipationInfo,
    },
    {
      path: '/participation-info-marathi',
      name: 'MarathiParticipationInfo',
      component: MarathiParticipationInfo,
    },
    {
      path: '/tests/:language',
      name: 'Tests',
      component: Tests,
      props: true,
    },
    {
      path: '/summary',
      name: 'Summary',
      component: Summary,
    },
    {
      path: '/results',
      name: 'Results',
      component: Results,
    },
    {
      path: '/check-result',
      name: 'CheckResults',
      component: CheckResults,
    },
    {
      path: '/language-selection',
      name: 'LanguageSelection',
      component: LanguageSelection,
    },
    {
      path: '/dashboard',
      component: Dashboard,
    },
  ],
  mode: 'history',
});

const isLoggedIn = () => {
  const token = window.localStorage.trustcircle_token;
  return !!token;
};

router.beforeEach((to, from, next) => {
  // console.log('beforeEach:', to, from);
  if (to.path !== '/data') {
    next();
  } else {
    console.log('routing to resources');
    if (isLoggedIn()) {
      next();
    } else {
      next({
        path: '/login',
      });
    }
  }
});

ga(router, 'UA-97456193-5');

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js